import {CSSProperties} from "react";
import {Icon, X} from "react-feather";
import {useTheme} from "styled-components";
import {Absolute, IconButton} from "components";
import {ButtonLoaderId, Clickable} from "interfaces";
import {SvgIconComponent} from "@mui/icons-material";

interface AbsoluteIconProps extends Clickable, CSSProperties {
  toolTip?: string;
  iconFill?: string;
  iconColor?: string;
  loaderId?: ButtonLoaderId;
  icon?: Icon | SvgIconComponent;
}

export const AbsoluteIcon: React.FC<AbsoluteIconProps> = (props) => {
  const {white, black} = useTheme();
  const {
    onClick,
    toolTip,
    loaderId,
    icon: Icon = X,
    iconColor = black,
    iconFill = "transparent",
    ...style
  } = props;
  return (
    <Absolute top={-5} right={-5} {...style}>
      <IconButton
        size={30}
        toolTip={toolTip}
        onClick={onClick}
        loaderId={loaderId}
        backgroundColor={white}
        style={{boxShadow: "0px 2px 3px 1px rgb(0,0,0, .1)"}}
        icon={
          <Icon
            size={16}
            fill={iconFill}
            style={{color: iconColor, fontSize: 16}}
          />
        }
      />
    </Absolute>
  );
};
